import PropTypes from "prop-types"
import React from "react"
import Transition from "../components/Transition"
import "./Layout.css"
import { useState, useEffect } from "react"
import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
} from "firebase/auth"
import { auth } from "../utils/firebase"

const Layout = ({ children, location }) => {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [user, setUser] = useState(null)

  useEffect(() => {
    // Listen for auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user)
    })

    // Cleanup subscription
    return () => unsubscribe()
  }, [])

  const handleSignIn = async (e) => {
    e.preventDefault()
    try {
      await signInWithEmailAndPassword(auth, email, password)
      setError(null)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleSignOut = async () => {
    try {
      await signOut(auth)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleResetPassword = async () => {
    if (!email) {
      setError("Please enter your email first.")
      return
    }

    try {
      await sendPasswordResetEmail(auth, email)
      setError(null)
      alert("Password reset email sent! Check your inbox.")
    } catch (err) {
      setError(err.message)
    }
  }

  if (user) {
    return (
      <div id="app" className="app">
        <script src="https://player.vimeo.com/api/player.js"></script>
        <button onClick={handleSignOut}>Sign Out</button>
        <Transition location={location}>{children}</Transition>
      </div>
    )
  }

  return (
    <div
      id="app"
      className="app flex flex-col justify-center items-center h-screen"
    >
      <h1>Sign In</h1>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSignIn} className="flex flex-col mx-auto">
        <div className="flex flex-row items-center mb-2.5 gap-2">
          <label className="font-serif w-25">Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-50 h-6 border border-gray-300 rounded-xs p-2 focus:border-primary"
          />
        </div>
        <div className="flex flex-row items-center mb-2.5 gap-2">
          <label className="font-serif w-25">Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-50 h-6 border border-gray-300 rounded-xs p-2 focus:border-primary"
          />
        </div>
        <button
          type="submit"
          className="mt-2.5 bg-primary rounded p-2 h-10 w-25 secondary "
        >
          Sign In
        </button>
        <button
          type="button"
          onClick={handleResetPassword}
          className="mt-2.5 bg-transparent text-primary border-none cursor-pointer font-serif secondary"
        >
          Forgot Password?
        </button>
      </form>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
